/* eslint-disable jsdoc/require-jsdoc */
import React from 'react';

function Checkbox({
  id, label, value, onChange,
}) {
  function handleCheckboxChange(event) {
    onChange(event.target.checked);
  }
  return (
    <div className="filter__field">
      <label className="filter__chk-box ended">
        <input id={id} type="checkbox" className="d-none" checked={value} onChange={handleCheckboxChange} />
        <span className="filter__chk-box-label m-r-10">{label}</span>
        <div className="filter__chk-box-icon" />
      </label>
    </div>
  );
}

export default Checkbox;
